module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.isAddValid),
      callback: function($$v) {
        _vm.isAddValid = $$v
      },
      expression: "isAddValid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [(_vm.showUpload) ? _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('input', {
    staticClass: "fileUpload",
    attrs: {
      "type": "file",
      "id": "plistFile"
    },
    on: {
      "change": _vm.fncReadCsv
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fileHolder"
  }, [_c('p', [_vm._v("Drag & Drop / Click to Add File")]), _vm._v(" "), _c('small', [_vm._v("Once you upload the file, the import will occurr")])])]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg2": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Active",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.pricelistActive),
      callback: function($$v) {
        _vm.pricelistActive = $$v
      },
      expression: "pricelistActive"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg2": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Default Pricelist",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.pricelistDefault),
      callback: function($$v) {
        _vm.pricelistDefault = $$v
      },
      expression: "pricelistDefault"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg2": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Cost Pricelist",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.pricelistCostPricelist),
      callback: function($$v) {
        _vm.pricelistCostPricelist = $$v
      },
      expression: "pricelistCostPricelist"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg2": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Pricelist Name:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Name",
      "rules": _vm.nameRules,
      "required": "",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.pricelistName),
      callback: function($$v) {
        _vm.pricelistName = $$v
      },
      expression: "pricelistName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Privilege Description:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Description",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.pricelistDescription),
      callback: function($$v) {
        _vm.pricelistDescription = $$v
      },
      expression: "pricelistDescription"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg1": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Currency Symbol:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Currency Symbol",
      "required": "",
      "rules": _vm.symbolRules,
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.pricelistCurrencySymbol),
      callback: function($$v) {
        _vm.pricelistCurrencySymbol = $$v
      },
      expression: "pricelistCurrencySymbol"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg1": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Tax Label:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Tax Label",
      "required": "",
      "rules": _vm.labelRules,
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.pricelistTaxLabel),
      callback: function($$v) {
        _vm.pricelistTaxLabel = $$v
      },
      expression: "pricelistTaxLabel"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg1": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Tax Rate(%):")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Tax Rate",
      "solo": "",
      "required": "",
      "rules": _vm.taxRules,
      "single-line": ""
    },
    model: {
      value: (_vm.pricelistTaxRate),
      callback: function($$v) {
        _vm.pricelistTaxRate = $$v
      },
      expression: "pricelistTaxRate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg1": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Currency Code:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Currency Code",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.pricelistCurrencyCode),
      callback: function($$v) {
        _vm.pricelistCurrencyCode = $$v
      },
      expression: "pricelistCurrencyCode"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "filterPrice",
    attrs: {
      "lg2": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Pricing Table:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.priceTableList,
      "label": "Type",
      "single-line": "",
      "solo": "",
      "item-value": "text"
    },
    on: {
      "change": _vm.fncFilterTable
    },
    model: {
      value: (_vm.pricelistTable),
      callback: function($$v) {
        _vm.pricelistTable = $$v
      },
      expression: "pricelistTable"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg2": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Action:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.pricelistActions,
      "label": "-",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.pricelistAction),
      callback: function($$v) {
        _vm.pricelistAction = $$v
      },
      expression: "pricelistAction"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg2": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Percentage: (%)")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.priceFilterPercentage),
      callback: function($$v) {
        _vm.priceFilterPercentage = $$v
      },
      expression: "priceFilterPercentage"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Roundup:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.pricelistRoundupItems,
      "label": "None",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.pricelistRoundItem),
      callback: function($$v) {
        _vm.pricelistRoundItem = $$v
      },
      expression: "pricelistRoundItem"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg2": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Items:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.pricelistFilterItems,
      "label": "All Items",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.pricelistFilterItem),
      callback: function($$v) {
        _vm.pricelistFilterItem = $$v
      },
      expression: "pricelistFilterItem"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg1": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v(" ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncApplyFilters()
      }
    }
  }, [_vm._v("Apply")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _c('br')], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.priceTableAllSelected,
      "search": _vm.search,
      "rows-per-page-items": [20, 40, 60, 80, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [(_vm.currentPriceTable == props.item.pli_pricing_table) ? _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "5%"
          }
        }, [_c('v-checkbox', {
          model: {
            value: (props.item.pli_filter),
            callback: function($$v) {
              _vm.$set(props.item, "pli_filter", $$v)
            },
            expression: "props.item.pli_filter"
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.currentPriceTable == props.item.pli_pricing_table) ? _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s(props.item.pli_code))]) : _vm._e(), _vm._v(" "), (_vm.currentPriceTable == props.item.pli_pricing_table) ? _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s(props.item.pli_description))]) : _vm._e(), _vm._v(" "), (_vm.currentPriceTable == props.item.pli_pricing_table) ? _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "25%"
          }
        }, [_vm._v(_vm._s(_vm.fncFormatPrice(props.item.pli_price)))]) : _vm._e(), _vm._v(" "), (_vm.currentPriceTable == props.item.pli_pricing_table) ? _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "20%"
          }
        }, [_c('v-text-field', {
          attrs: {
            "solo": ""
          },
          model: {
            value: (props.item.pli_new_price),
            callback: function($$v) {
              _vm.$set(props.item, "pli_new_price", $$v)
            },
            expression: "props.item.pli_new_price"
          }
        })], 1) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncDownloadTemplate.apply(null, arguments)
      }
    }
  }, [_vm._v("Download Template")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncShowUpload.apply(null, arguments)
      }
    }
  }, [_vm._v("Import")]), _vm._v(" "), (_vm.runAdd) ? _c('v-progress-circular', {
    staticClass: "pt-3 loginLoader",
    attrs: {
      "indeterminate": "",
      "width": 3,
      "size": 20,
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.runAdd) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": !_vm.isAddValid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncAddPlist()
      }
    }
  }, [_vm._v("Add")]) : _vm._e(), _vm._v(" "), _c('small', [_vm._v("* The button will activate once all required fields have been completed")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}